import { roundValue, Unit } from "../processors";
import { median } from "d3";

export const appMedian = (values: number[], unit?: Unit) => {
    if (!values?.length) return null;
    const average = median(values);
    return unit == null ? average : roundValue(average ?? 0, unit as Unit, true, false).value;
};
